import React from "react";
import "./Brands.css"; // import the CSS file

const Brands = () => {
  const brands = [
    {
      name: "Zara",
      banner:
        "https://www.graphicdesignforum.com/uploads/default/original/2X/6/6335553d8b489fb58d53d121076f42933bbeda35.jpeg",
    },
    {
      name: "Aritzia",
      banner:
        "https://thelesabre.com/wp-content/uploads/2024/04/Keithston-and-Partners-1200x675.jpg",
    },
    {
      name: "Saks",
      banner:
        "https://sourcingjournal.com/wp-content/uploads/2018/03/Saks-Logo-Cropped.jpg?w=672",
    },
    {
      name: "Skims",
      banner:
        "https://customeazy.com/cdn/shop/products/skims_logo_sticker_iron-on_600x.jpg?v=1583663211",
    },
  ];

  return (
    <div className="brands-section">
      <h2 className="brands-title">Our Brands</h2>
      <p className="brands-subtitle">
        Discover top brands that we partner with to bring you the best in fashion and style.
      </p>
      <div className="brands-scroll-container">
        {brands.map((brand, index) => (
          <div key={index} className="brand-card">
            <img src={brand.banner} alt={brand.name} className="brand-image" />
            <h3 className="brand-name">{brand.name}</h3>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Brands;
